// extracted by mini-css-extract-plugin
module.exports = {"scriptEmbedWrapper":"embedBlock_scriptEmbedWrapper__rBpte"};